@layer app {
.modal-title {
            color: var(--text-primary);
            font-size: var(--font-size-xl);
            font-weight: 500;
            line-height: $size-26;
    }
} // layer app










@layer context {
.modal-title:global(.refer-and-earn-modal-title) {
            margin-bottom: $size-20;
            color: var(--banky-black);
            font-style: normal;
            text-align: left;
    }
} // layer context
